<template>
    <div style="height: 0px; position: absolute; left: -20px">
        <img :src="$common.access_count + page_tag" style="height: 0px"/>
    </div>
</template>

<script>
    export default {
        name: "Wp_access_count",
        props:{
            pageTag: {type: String, defaule: ''},
        },
        data(){
            return{
                page_tag: '',
            }
        },
        created() {
            this.initPageTag();
        },

        methods:{

            loadImg(){
                // let img = new Image();
                // img.src = this.$common.access_count + this.page_tag;
            },

            /**
             * 配置计数器的page_tag
             */
            initPageTag(){
                if(this.pageTag){
                    // if(this.$config.project === 'mini'){//小程序
                    //     this.page_tag = this.pageTag + '_mini';
                    // }else if(this.$config.project === 'hm'){//河马
                    //     this.page_tag = this.pageTag + '_hm_' + this.$store.state.channel_username;
                    //
                    // }else if(this.$common.isClient_whole()){//二级页面
                    //     this.initClientTag(this.$config.project);
                    // }else{//h5（jd）
                    //     this.page_tag = this.pageTag;
                    // }

                    // if(this.$config.project === 'mini'){//小程序
                    //     this.page_tag = this.pageTag + '_mini';
                    // }else
                    if(this.$common.isClient_whole()) {//二级页面
                        this.initClientTag_active();
                    }else{
                        this.page_tag = this.pageTag;
                    }

                }
            },

            /**
             * 配置二级页面的page_tag
             * @param client 二级页面配置对应的project（client或client_hm）
             */
            initClientTag(client){
                this.$log("client = " + client);
                this.page_tag = this.pageTag + '_' + client + '_' + this.$store.state.channel_username;
                //如果是活动页面
                //http://a004.wapg.cn/#/home_s?sub_path=page_1581059667&channel_name=a004
                let sub_path = this.$common.getUrlKey("sub_path");
                if(sub_path){
                    this.page_tag = this.pageTag + '_' + client + '_' + this.$store.state.channel_username + '_' + sub_path;
                }
            },

            /**
             * 配置二级页面的page_tag(只区分活动页)
             * @param client 二级页面配置对应的project（client或client_hm）
             */
            initClientTag_active(){
                //如果是活动页面
                //http://a004.wapg.cn/#/home_s?sub_path=page_1581059667&channel_name=a004
                let sub_path = this.$common.getUrlKey("sub_path");
                if(sub_path){
                    if(this.pageTag === 'home'){
                        this.page_tag = sub_path;
                    }else{
                        this.page_tag = sub_path + '_' + this.pageTag;
                    }
                }else{
                    this.page_tag = this.pageTag;
                }
            }
        }
    }
</script>

<style scoped>

</style>